import { withFirebase } from "../Firebase";
import React, { Component } from "react";

import Spinner from "react-md-spinner";
import { Button } from "@blueprintjs/core";
import { Grid, Row, Col } from "react-flexbox-grid";
import "./index.css";

import Repeat from "react-repeat-component";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { PieChart, Pie, Tooltip } from "recharts";

//individual / summery

//## summery
//Check question type
/*  
- if mcq make a count of responsis for the options, display it in a pie diagram 
- if checkbox make a count for the existing combinations, display it in a pie or histogram diagram 
- if short / long questions just display them as a list and when clicked maybe display the name / id of the user
*/

//## individual
/*  
- Display full name - id when toggled display the answers, for each question 
*/

class Survey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewSummary: true,
      loading: true,
      userlist: [],
    };
  }

  async componentDidMount() {
    //fetch registations ...
    let snap_regisrtations = await this.props.firebase
      .registrations(this.props.eventId)
      .get();
    let regisrtations = snap_regisrtations.docs.map((doc) => {
      return {
        ...doc.data(),
        id: doc.id,
      };
    });
    //fetch user data...
    let promises = regisrtations.map((registation) =>
      this.props.firebase.realUser(registation.id).get()
    );
    let snap_users = await Promise.all(promises);
    let users = snap_users.map((doc) => {
      return {
        ...doc.data(),
        id: doc.id,
      };
    });

    let userList = regisrtations.map((val) => {
      var id = val.id;
      var index = users.findIndex((val) => val.id === id);
      return { ...val, ...users[index] };
    });

    this.setState({
      loading: false,
      userlist: userList,
    });
  }

  handelView = () => {
    this.setState({ viewSummary: !this.state.viewSummary });
  };
  render() {
    const { loading, userlist } = this.state;
    if (loading) return <Spinner />;
    else
      return (
        <Grid>
          <Row middle="xs">
            <Col>
              <Button
                onClick={this.handelView}
                disabled={!this.state.viewSummary}
              >
                Individual
              </Button>
            </Col>
            <Col>
              <Button
                onClick={this.handelView}
                disabled={this.state.viewSummary}
              >
                Summary
              </Button>
            </Col>
          </Row>

          <Row>
            {this.state.viewSummary ? (
              <SummaryView
                questions={this.props.form.questions}
                nQuestions={this.props.form.questions.length}
                userlist={userlist}
              />
            ) : (
              <IndividualView
                questions={this.props.form.questions}
                nQuestions={this.props.form.questions.length}
                userlist={userlist}
              />
            )}
          </Row>
        </Grid>
      );
  }
}

const createDataCBQ = (users_answers, question) => {
  //create option list and count at the same time,
  //create users mappings
  let options_list = [];
  let answer_mapping = []; //list all users with specific answer
  let options = [];

  console.log(users_answers); 
  for (let user of users_answers) {
    if (user.form_response === undefined || Object.keys(user.form_response).length === 0 ) continue;
    let answers = user.form_response;
    let question_answer = answers.hasOwnProperty(question) ? answers[question] : []; //an array
    let option_selected = "";
    for (let j in question_answer) {
      //if list of selected options are unique append them to option_list
      //else we will just increase the count

      if (question_answer[j] === true) {
        option_selected += j + " ";
      }
    }
    option_selected = option_selected.trim();
    if (options_list.hasOwnProperty(option_selected)) {
      options_list[option_selected] += 1;
      answer_mapping[option_selected].push(user);
    } else {
      if (option_selected === "") continue;
      options_list[option_selected] = 1;
      if (question_answer === "-") continue;
      answer_mapping[option_selected] = [user];
      options.push(option_selected);
    }
  }

  //create the data list
  let data_list = [];

  // users: answer_mapping
  for (let i of options) {
    i = i.trim();
    console.log(i + " " + options_list[i]);
    data_list.push({ name: i, value: options_list[i], users: answer_mapping });
  }

  return data_list;
};
const createDataMCQ = (options, users_answers, question) => {
  //create option list to count the answers
  let options_list = [];
  let answer_mapping = []; //list all users with specific answer

  for (let i in options) {
    options_list[options[i].trim()] = 0;
    answer_mapping[options[i].trim()] = [];
  }
  console.log(options_list);
  console.log(answer_mapping);
  console.log(question);
  //loop through users filter the answers with question key == question
  for (let user of users_answers) {
    if (user.form_response === undefined || Object.keys(user.form_response).length === 0 ) continue;
    let answers = user.form_response;
    if (answers[question] === undefined) continue;

    //accumalte the options values and return them
    let question_answer = answers[question].trim();
    if (question_answer === "-") continue;
    options_list[question_answer] += 1;
    if (question_answer) answer_mapping[question_answer].push(user);
  }

  //create the data list
  let data_list = [];

  for (let i of options) {
    i = i.trim();

    if (options_list[i] === 0) continue;

    data_list.push({ name: i, value: options_list[i], users: answer_mapping });
  }

  return data_list;
};

const SummaryView = (props) => {
  const { userlist, questions } = props;

  console.log(questions);
  return (
    <Grid>
      {questions.map((question) => {
        if (question.type === "mcq") {
          return (
            <Row>
              <Col>
                {" "}
                <strong> {question.text}</strong>
              </Col>
              <Col>
                <PieChart width={800} height={400}>
                  <Pie
                    isAnimationActive={false}
                    data={createDataMCQ(
                      question.options,
                      userlist,
                      question.text
                    )}
                    cx={500}
                    cy={200}
                    outerRadius={100}
                    fill="#008ac9"
                    label
                  />
                  <Tooltip />
                </PieChart>
              </Col>
            </Row>
          );
        } else if (question.type === "cbq") {
          return (
            <Row>
              <Col>
                <strong> {question.text}</strong>
              </Col>
              <Col>
                <PieChart width={800} height={400}>
                  <Pie
                    isAnimationActive={false}
                    data={createDataCBQ(userlist, question.text)}
                    cx={500}
                    cy={200}
                    outerRadius={100}
                    fill="#008ac9"
                    label
                  />
                  <Tooltip />
                </PieChart>
              </Col>
            </Row>
          );
        } else if (
          question.type === "long_text" ||
          question.type === "short_text" ||
          question.type === "text"
        ) {
          return (
            <Row>
              <Col>
                <strong> {question.text}</strong>
              </Col>
              <Col>
                <ol>
                  
                    {userlist.map((user) => {

                           if(user.form_response === undefined || Object.keys(user.form_response).length === 0)
                           return  <li>"N/A"</li>
                           else if(user.form_response[question.text] === undefined) return <li>"N/A"</li>
                           else return <li key={user.id}>
                                          {user.firstname + " " + user.familyname} :
                                           {user.form_response[question.text]}
                                    </li>

                    })}
               
                </ol>
              </Col>
            </Row>
          );
        }
      })}
    </Grid>
  );
};

const displayCbq = (cbqs) => {
  let option_selected = "";
  for (let j in cbqs) {
    if (cbqs[j] === true) {
      option_selected += j + " ";
    }
  }
  return option_selected;
};
const IndividualView = (props) => {
  const { nQuestions, userlist, questions } = props;
  return (
    <Accordion allowMultipleExpanded={true}>
      <Repeat times={userlist.length}>
        {(i) => (
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>
                <strong>
                  {" "}
                  User {i + 1}:{" "}
                  {userlist[i].firstname + " " + userlist[i].familyname}
                </strong>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <ol>
                <Repeat times={nQuestions}>
                  {(j) => {
                    if (questions[j].type === "cbq") {
                      return (
                        <div key={j}>
                          <li>
                            {questions[j].text + " "}:{" "}
                            {userlist[i].form_response === []
                              ? ""
                              : displayCbq(
                                  userlist[i].form_response[questions[j].text]
                                )}{" "}
                          </li>
                        </div>
                      );
                    } else if (questions[j].type === "mcq") {
                      return (
                        <div key={j}>
                          <li>
                            {questions[j].text + " "}:{" "}
                            {userlist[i].form_response === []
                              ? ""
                              : userlist[i].form_response[
                                  questions[j].text
                                ]}{" "}
                          </li>
                        </div>
                      );
                    } else {
                      return (
                        <div key={j}>
                          <li>{questions[j].text}:</li>
                          <p>
                            {" "}
                            {userlist[i].form_response === []
                              ? ""
                              : userlist[i].form_response[
                                  questions[j].text
                                ]}{" "}
                          </p>
                        </div>
                      );
                    }
                  }}
                </Repeat>
              </ol>
            </AccordionItemPanel>
          </AccordionItem>
        )}
      </Repeat>
    </Accordion>
  );
};

export default withFirebase(Survey);
